{
  "nav": {
    "pricing": "Preços",
    "contact": "Contacto",
    "menu": "Menu",
    "login": "Iniciar sessão",
    "features": "Funcionalidades",
    "brandHomeAria": "Done-it — início",
    "market": {
      "belgium": "Bélgica",
      "international": "Mundial"
    }
  },
  "footer": {
    "tagline": "Done-it — Registo de horas, simples.",
    "terms": "Termos",
    "privacy": "Privacidade",
    "contact": "Contacto"
  },
  "help": "Precisas de ajuda?",
  "continue": "Continuar",
  "back": "Voltar",
  "change": "Alterar",
  "retry": "Tentar novamente",
  "errors": {
    "unexpected": "Erro inesperado"
  },
  "step": {
    "of": "Passo {{n}} de {{total}}"
  },
  "funnel": {
    "title": "Subscrição · Done-it"
  }
}
